import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "add-tag",
  "use": "add-tag-usage",
  "viewBox": "0 0 26 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 26 22\" id=\"add-tag\"><path stroke=\"#A4A4AD\" d=\"M1 3a2 2 0 0 1 2-2h14.203a2 2 0 0 1 1.375.548l5.797 5.489A2 2 0 0 1 25 8.489v4.987a2 2 0 0 1-.62 1.448l-5.8 5.524A2 2 0 0 1 17.2 21H3a2 2 0 0 1-2-2V3z\" clip-rule=\"evenodd\" /><path stroke=\"#A4A4AD\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.25\" d=\"M11 7.5v7M7.5 11h7\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol